// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createChatMuteClear from "./chatMute/postChatMuteClear";
import createChatMuteGet from "./chatMute/postChatMuteGet";
import createChatMuteSet from "./chatMute/postChatMuteSet";
import createDeviceRegister from "./device/postDeviceRegister";
import createDeviceUnregister from "./device/postDeviceUnregister";
import createInboxGetUnreadCount from "./inbox/postInboxGetUnreadCount";
import createInboxList from "./inbox/postInboxList";
import createInboxMarkAllRead from "./inbox/postInboxMarkAllRead";
import createInboxMarkRead from "./inbox/postInboxMarkRead";
import createNotificationSettingsApplyPreset from "./notificationSettings/postNotificationSettingsApplyPreset";
import createNotificationSettingsClearPoolOverride from "./notificationSettings/postNotificationSettingsClearPoolOverride";
import createNotificationSettingsGetGame from "./notificationSettings/postNotificationSettingsGetGame";
import createNotificationSettingsGetGlobal from "./notificationSettings/postNotificationSettingsGetGlobal";
import createNotificationSettingsGetPool from "./notificationSettings/postNotificationSettingsGetPool";
import createNotificationSettingsGetQuietHours from "./notificationSettings/postNotificationSettingsGetQuietHours";
import createNotificationSettingsGetTeam from "./notificationSettings/postNotificationSettingsGetTeam";
import createNotificationSettingsSetAlertChannel from "./notificationSettings/postNotificationSettingsSetAlertChannel";
import createNotificationSettingsSetEmailKillSwitch from "./notificationSettings/postNotificationSettingsSetEmailKillSwitch";
import createNotificationSettingsSetGameAlert from "./notificationSettings/postNotificationSettingsSetGameAlert";
import createNotificationSettingsSetGameFollow from "./notificationSettings/postNotificationSettingsSetGameFollow";
import createNotificationSettingsSetPoolAlertChannel from "./notificationSettings/postNotificationSettingsSetPoolAlertChannel";
import createNotificationSettingsSetQuietHours from "./notificationSettings/postNotificationSettingsSetQuietHours";
import createNotificationSettingsSetTeamAlert from "./notificationSettings/postNotificationSettingsSetTeamAlert";
import createNotificationSettingsSetTeamFollow from "./notificationSettings/postNotificationSettingsSetTeamFollow";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postChatMuteClear: createChatMuteClear(resolvedOptions),
    postChatMuteGet: createChatMuteGet(resolvedOptions),
    postChatMuteSet: createChatMuteSet(resolvedOptions),
    postDeviceRegister: createDeviceRegister(resolvedOptions),
    postDeviceUnregister: createDeviceUnregister(resolvedOptions),
    postInboxGetUnreadCount: createInboxGetUnreadCount(resolvedOptions),
    postInboxList: createInboxList(resolvedOptions),
    postInboxMarkAllRead: createInboxMarkAllRead(resolvedOptions),
    postInboxMarkRead: createInboxMarkRead(resolvedOptions),
    postNotificationSettingsApplyPreset:
      createNotificationSettingsApplyPreset(resolvedOptions),
    postNotificationSettingsClearPoolOverride:
      createNotificationSettingsClearPoolOverride(resolvedOptions),
    postNotificationSettingsGetGame:
      createNotificationSettingsGetGame(resolvedOptions),
    postNotificationSettingsGetGlobal:
      createNotificationSettingsGetGlobal(resolvedOptions),
    postNotificationSettingsGetPool:
      createNotificationSettingsGetPool(resolvedOptions),
    postNotificationSettingsGetQuietHours:
      createNotificationSettingsGetQuietHours(resolvedOptions),
    postNotificationSettingsGetTeam:
      createNotificationSettingsGetTeam(resolvedOptions),
    postNotificationSettingsSetAlertChannel:
      createNotificationSettingsSetAlertChannel(resolvedOptions),
    postNotificationSettingsSetEmailKillSwitch:
      createNotificationSettingsSetEmailKillSwitch(resolvedOptions),
    postNotificationSettingsSetGameAlert:
      createNotificationSettingsSetGameAlert(resolvedOptions),
    postNotificationSettingsSetGameFollow:
      createNotificationSettingsSetGameFollow(resolvedOptions),
    postNotificationSettingsSetPoolAlertChannel:
      createNotificationSettingsSetPoolAlertChannel(resolvedOptions),
    postNotificationSettingsSetQuietHours:
      createNotificationSettingsSetQuietHours(resolvedOptions),
    postNotificationSettingsSetTeamAlert:
      createNotificationSettingsSetTeamAlert(resolvedOptions),
    postNotificationSettingsSetTeamFollow:
      createNotificationSettingsSetTeamFollow(resolvedOptions),
  };
}
